/**
 * Runtime branding overrides.
 *
 * `window.__BRANDING__` is populated by `/config/branding.js`, which ships
 * with neuRealities defaults (an empty object) and is overwritten at
 * container start by `docker/render-branding.sh` when APP_NAME / BRAND_LOGO
 * / BRAND_LOGO_DARK / BRAND_ICON are set. Each consumer falls back to its own literal default
 * when a field is absent, so an unset deployment behaves exactly as before.
 */
export interface Branding {
  appName?: string
  logoUrl?: string
  // Dark-theme logo variant (BRAND_LOGO_DARK, SA-337). Consumed only through
  // hooks/useBrandLogo, which falls back to logoUrl; the icon has no variant.
  logoDarkUrl?: string
  iconUrl?: string
  // App chrome primary color (APP_PRIMARY env) — "#RRGGBB" or "r g b"
  // triplet. applyBrandTheme derives a full 50-900 scale from it and
  // overrides the --primary-* vars backing the Tailwind `primary` palette.
  appPrimary?: string
  // W3 per-instance brand color tokens — space-separated RGB channel triplets
  // (e.g. "37 99 235"), consumed as CSS vars for the Tailwind `brand` family.
  brandPrimary?: string
  brandAccent?: string
  brandInk?: string
  brandTint?: string
  brandWash?: string
  brandBorder?: string
}

export function getBranding(): Branding {
  if (typeof window === 'undefined') return {}
  return (window as unknown as { __BRANDING__?: Branding }).__BRANDING__ ?? {}
}
